/* Reopen Shopify's native preferences; never change consent automatically. */
(() => {
  if (window.drapeurCookiePreferencesBound) return;
  window.drapeurCookiePreferencesBound = true;
  const waitForBanner = () => new Promise((resolve, reject) => {
    let attempts = 0;
    const check = () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        resolve(window.privacyBanner);
      } else if (++attempts < 30) {
        window.setTimeout(check, 100);
      } else {
        reject(new Error('Shopify privacy banner unavailable'));
      }
    };
    check();
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-drapeur-cookie-preferences]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    waitForBanner().then((banner) => banner.showPreferences()).catch(() => {
      window.location.assign(link.href);
    });
  });
})();
